// 新聞列表頁側邊欄
import { useState, useEffect } from 'react';
import { PROMO_BANNER_POSITION_CODE } from '@/common/constant';
import promoClient from '@/common/apiClient/promoClient';
import AdN101 from '../ad/AdN101'; // 側邊社群廣告
import AsideTopNews from './AsideTopNews'; // 分類 top 新聞

const NewsListAside = ({ category, locale }) => {
    const [banner, setBanner] = useState(null); // 社群廣告

    // 取得側邊廣告
    const getBanner = async () => {
        try {
            const result = await promoClient.getPromoBanner(
                PROMO_BANNER_POSITION_CODE.ASIDE_SOCIAL
            );
            if (result.status === 'success') {
                setBanner(result?.banners?.[0]);
            }
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        getBanner();
    }, []);

    return (
        <aside className="w-[330px] flex-shrink-0 ulg:hidden">
            {/* 廣告欄位 */}
            <AdN101 location="news" />

            {/* 分類 top 新聞 */}
            <AsideTopNews category={category} locale={locale} />
        </aside>
    );
};

export default NewsListAside;
